import styled from 'styled-components';
import {
  ButtonBase,
  PrimaryLink,
  BaseColumnWrap,
} from '../../../../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';
import Image from '@stencil/image';

export const MultiRoomComboSection = styled.section(
  props => `
    display:flex;
    flex-direction:column;
    width:100%;
    border-radius: ${props.theme.misc.borderRadius.base};
    margin: ${props.theme.spacing.xlarge} 0 0 0;
    
    `,
);

export const HeaderDiv = styled(BaseColumnWrap)(
  props => `
    width:34%;
    border-bottom:0.2rem solid #E1E7EE;
    background:#ffffff;
    padding:1rem 1.2rem;
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
      `,
);

export const MultiRoomHeaderPara = styled.p(
  props => `
    font-size: ${props.theme.font.custom(16)};
    padding-bottom: ${props.theme.spacing.xsmall};
    font-weight: 600;
    `,
);

export const MultiRoomSubHeaderPara = styled.p(
  props => `
    font-size: ${props.theme.font.custom(12)};
    color: ${props.theme.colors.goGreen.medium};
    `,
);

export const MainContentDiv = styled.div(
  props => `
    display:flex;
    flex-direction:row;
    width:100%;
    border-bottom-left-radius: 1rem;
    border-bottom-right-radius: 1rem;
    `,
);

export const MainContentLeftDiv = styled.div(
  props => `
    display:flex;
    flex-direction:column;
    width:85%;
    border-right:0.1rem solid #E1E7EE;
    li{
        display:flex;
        flex-direction: row;
        border-bottom:0.1rem solid #E1E7EE;
        &:last-child{
            border-bottom:none;
        }
        li{
            display:flex;
            flex-direction:column;
            // width:33.3%;
            flex:1;
            border-right:0.1rem solid #E1E7EE;
            border-bottom:none;
            &:last-child{
                border-right:none;
            }
        }
    }

    `,
);

export const MainContentRightDiv = styled.div(
  props => `
    display:flex;
    flex-direction:column;
    width:330px;
    padding: 6rem;
    align-items: baseline;
    background-color:#ffffff;
    justify-content:center;
    `,
);

export const StrickedPricePara = styled.p(
  props => `
    font-size: ${props.theme.font.custom(12)};
    color: ${props.theme.colors.ash.base};
    text-decoration: line-through;
    padding-bottom: ${props.theme.spacing.small};
    `,
);

export const OriginalPricePara = styled.p(
  props => `
    font-size: 2.2rem;
    font-weight: 600;
    padding-bottom: ${props.theme.spacing.small};
    `,
);

export const TaxInclusionPara = styled.p(
  props => `
    font-size: ${props.theme.font.custom(12)};
    padding-bottom: ${props.theme.spacing.small};

    `,
);

export const RoomsAvailablePara = styled.p(
  props => `
    font-size: ${props.theme.font.custom(12)};
    color: ${props.theme.colors.ash.base};
    padding-bottom: ${props.theme.spacing.small};

    `,
);

export const ComboBtn = styled(ButtonBase)(
  props => `
    border-radius:5rem;
    width:100%;
    padding-top:${props.theme.spacing.large};
    padding-bottom:${props.theme.spacing.large};
    background-color :#fff;
    border:1.5px solid #ff6d38;
    color:#ff6d38;
    padding:1rem 2rem;
    margin-top:10px;
    `,
);

export const AddonsWrapper = styled.ul(
  props => `
  width:100%;
  display:flex;
  flex-direction: column;
  padding:${props.theme.spacing.large} ${props.theme.spacing.xlarge};
  border-right:none;
  li{
      display:flex;
      width:100%;
      flex-direction:row !important;
      padding-bottom: ${props.theme.spacing.base};
      border-right:none !important;
  }
  
  `,
);

export const UpgradeComplementWrapper = styled.span(
  props => `
    width:95%;
    display:flex;
    font-size:${props.theme.font.custom(14)};
    padding-left:10px;
`,
);

export const TribeImg = styled(Image)(
  props => `
      width: 6rem;
      
      `,
);

export const ViewMoreLink = styled(PrimaryLink)(
  props => `
    padding-left:${props.theme.spacing.xlarge};
    font-size:${props.theme.font.custom(14)};
    
`,
);

export const RoomUpgradeWrapper = styled.div(
  props => `
    width:95%;
    display:flex;
    padding:${props.theme.spacing.small};
    background-color:#fef8e5;
    border-radius: 3rem;
    font-size:${props.theme.font.custom(14)};
    justify-content:space-between;
`,
);

export const RoomTypeWrapper = styled.div(
  props => `
    width:100%;
    display:flex;
    flex-direction:row;
    padding:${props.theme.spacing.large} ${props.theme.spacing.xlarge};
    
`,
);

export const RoomTypeImageBlock = styled.div(
  props => `
    width:45%;
    display:flex;
    flex-direction:column;
    margin-right:${props.theme.spacing.large};
    
`,
);

export const RoomTypeRightDiv = styled.div(
  props => `
    width:55%;
    display:flex;
    flex-direction:column;
    
    
`,
);

export const RoomTypeImage = styled(Image)(
  props => `
    width: 178.9px;
    height: 12.8rem;
    border-radius:1.2rem;
    margin-right: 30px;
    position:relative;
    cursor:pointer;
    `,
);

export const ViewMoreDetailsLink = styled(PrimaryLink)(
  props => `
  display:flex;
  padding-top:${props.theme.spacing.small};
  font-size:${props.theme.font.custom(12)};
  padding-left: 0;
`,
);

export const RoomSizeSpan = styled.span(
  props => `
    font-size: ${props.theme.font.custom(14)};
    padding-bottom: ${props.theme.spacing.small};
    font-weight:500;
    display:flex;
    align-items:center;
`,
);

export const BedTypeSpan = styled.span(
  props => `
    font-size: ${props.theme.font.custom(14)};
    font-weight:500;
`,
);

export const RoomDetailsDiv = styled.div(
  props => `
    display:flex;
    flex-direction:column;
    width:100%;
    // padding:${props.theme.spacing.large} ${props.theme.spacing.xlarge};
`,
);

export const PropertyTypePara = styled.p(
  props => `
    font-size:${props.theme.font.custom(14)};
    font-weight: 600;
    padding-bottom:${props.theme.spacing.base};
    `,
);

export const PaxDetailsDiv = styled.div(
  props => `
    width:100%;
    flex-direction:column;
    margin-bottom: ${props.theme.spacing.base};
    margin-top:1rem;
    margin-right: 0;
    border-left:none;
    `,
);

export const PaxDetailsInnerDiv = styled(BaseColumnWrap)(
  props => `
    padding-left: 0;
    `,
);

export const TotalPaxCountSpan = styled.span(
  props => `
    font-size: ${props.theme.font.custom(14)};
    color:#5d5d5d;
    `,
);

export const AmenitiesDetailsWrapper = styled.div(
  props => `
    padding-top:${props.theme.spacing.base};
    display:flex;
    flex-direction:row;
`,
);

export const MealsSpan = styled.span(
  props => `
    padding-right:${props.theme.spacing.base};
    font-size:${props.theme.font.custom(14)};
    color:${props.color ? props.color : ''};
    
`,
);

export const RedAlertSpan = styled.span(
  props => `
    font-size:${props.theme.font.custom(14)};
    color:${props.color ? props.color : props.theme.colors.goRed.base};
`,
);

export const GreenAlertSpan = styled.span(
  props => `
    font-size:${props.theme.font.custom(14)};
    color:${props.theme.colors.goGreen.base};
`,
);

export const FlexWrap = styled.div(
  props => `
      display:flex;
      `,
);

export const CancellationPolicyList = styled.ul(
  props => `
  padding: ${props.theme.spacing.xlarge};
  border-top: 2px solid ${props.theme.colors.goBrandBlue.light}
  list-style-type: none;
`,
);

export const CancellationPolicyListItem = styled.li(
  props => `
  padding: 0 0 ${props.theme.spacing.large} 0;
  list-style-type:none;
`,
);

export const CancellationItemText = styled.span(
  props => `
  font-size: ${props.theme.font.custom(16)};
  padding: 0 0 0 ${props.theme.spacing.base};

  /* font idiosyncrasies */
  position: relative;
  top: -3px;
`,
);

export const RoomImageOuterWrapper = styled.div(
  props => `
      position:relative;
      cursor:${props.isImageExists ? 'pointer' : ''};
  `,
);

export const MultiRoomRow = styled.div(
  props => `
  border-bottom: ${props.showBorderBottom ? '.8rem solid #E1E7EE' : ''};
  display: flex;
  background-color:#ffffff;
  height:100%;
`,
);

export const RoomTypeRightPara = styled.div(
  props => `
    display:flex;
    flex-direction:column;
`,
);

export const LeftDiv = styled.div(
  props => `
    flex:1;
    border-right:0.1rem solid #E1E7EE;
`,
);

export const RightDiv = styled.div(
  props => `
    width: 232px;
    padding:${props.theme.spacing.custom(18)};
    display:flex;
    flex-direction: column;
    align-items: flex-end;
    
`,
);

export const MultiRoomMainContainer = styled.div(
  props => `
    display:flex;
    background-color:white;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
`,
);

export const MultiRoomLeftCol = styled.div(
  props => `
    width: 410px;
    flex-shrink: 0;
    padding:${props.theme.spacing.custom(18)};
    border-right:0.1rem solid #E1E7EE;
    display:flex;
    align-items: normal;
    flex-direction:column;
`,
);

export const MultiRoomMiddleCol = styled.div(
  props => `
    width: 0px;
`,
);

export const MultiRoomRightCol = styled.div(
  props => `
    flex: 1;
    padding:${props.theme.spacing.custom(18)};
`,
);

export const RoomCount = styled.span(
  props => `
    display: flex;
   
    font-weight: 600;
    color: rgb(255,255,255);
    background-color: rgba(0,0,0,0.8);
    position: absolute;
    bottom: 10px;
    left:10px;
    padding: 0.8rem 2.4000000000000004rem 0.8rem 0.8rem;
    border-radius: 6px;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    cursor:pointer;
   &:after{
      border: solid #fff;
      border-width: 0 0.2rem 0.2rem 0;
      display: inline-block;
      padding: 0.3rem;
      transform: rotate(-45deg);
      position: absolute;
      right: 1rem;
      top: 1.3rem;
      content: "";
    }
`,
);

export const ComboOfferInnerSection = styled.section(
  props => `
    display:flex;
    width:45rem;
    flex-direction:column;
    padding:${props.theme.spacing.base} ${props.theme.spacing.custom(40)};
    background:white;
    justify-content:space-between;
    border-radius: ${props.theme.misc.borderRadius.custom(50)};
    margin:0 auto;
    margin-top:${props.theme.spacing.base};
    margin-bottom:${props.theme.spacing.base};
    box-shadow: 0 1px 4px 0 rgba(185, 186, 210, 0.3);
    
    `,
);

export const ComboTextSpan = styled.span(
  props => `
      font-size:${props.theme.font.custom(16)};
    font-weight: 600;
    padding-right:${props.theme.spacing.base};
      
      `,
);

export const FlexItemCenter = styled.div(
  props => `
      display:flex;
      align-items: ${props.alignitem || 'center'};
      `,
);

export const ComboHeader = styled(FlexItemCenter)(
  props => `
    justify-content:center;
    padding-bottom:${props.theme.spacing.small};
    `,
);

export const ComboDetailsLink = styled(PrimaryLink)(
  props => `
    font-size: ${props.theme.font.custom(14)};
    width:100%;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
  text-align:center;
    `,
);

export const WrapperSpan = styled.div(
  props => `
  display: inline-flex;
  cursor: pointer;
`,
);

export const ArrowUpIconWrapperSpan = styled.span(
  props => `
  height: 1.6rem;
  width: 1.6rem;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  margin: ${props.theme.spacing.xsmall} 0 0 ${props.theme.spacing.small};
  font-size: ${props.theme.font.xsmall};
  svg{
    // transform: rotate(180deg);
  }
`,
);

export const Room_detail_Wrap = styled.div(
  props => `
    display:flex;
    flex-direction:column;
    padding-right:  0;
      `,
);

export const Room_type_text = styled.p(
  props => `
    font-size: ${props.theme.font.custom(16)};
    font-weight: 600;
    // margin-bottom: ${props.theme.spacing.large};
    `,
);

export const Pax_type_text = styled.p(
  props => `
    font-size: ${props.theme.font.custom(16)};
    display:flex;
    align-item: center;
    margin-bottom: ${props.theme.spacing.large};
    `,
);

export const RoomSize_Details = styled.div(
  props => `
      display:flex;
      flex-direction:column;
      margin-left:${props.theme.spacing.custom(20)};
  `,
);

export const UpsellRoomStaticFlex = styled.div(
  props => `
    font-size: ${props.theme.font.custom(14)};
    padding-bottom: 2rem;
    display:flex;
    align-items: center;
`,
);

export const UpsellRoomStaticTextTypeSpan = styled.p(
  props => `
    font-size: ${props.theme.font.custom(14)}; 
    margin-left:10px;
    // width:80px;
`,
);
